export const privacyRouteWhitelist = ['/login', '/help', '/discover', '/dsico'];
